import { LocalVideoTrack } from 'livekit-client';
import { localTracksStore } from 'state/store/localTracks/localTracks';

export const selectLocalVideoTrack = (): LocalVideoTrack | null => {
    return localTracksStore.localVideoTrack;
};
